import { useCustom } from "@refinedev/core";
import { MediaTiming } from "types";

/**
 * Fetches chapter timings for a media item from GET /media/{mediaId}/timings.
 * Used to draw chapter milestone lines on analytics charts. Errors are
 * silenced because manually uploaded videos currently return a 500.
 */
export const useMediaTimings = (mediaId: string | null | undefined) => {
  const { data } = useCustom<MediaTiming>({
    url: `media/media/${mediaId}/timings`,
    method: "get",
    errorNotification: false,
    queryOptions: {
      enabled: Boolean(mediaId),
    },
  });

  const chapters = data?.data?.chapters;

  // Video length in seconds, derived from the last chapter's end (timestamps
  // are in milliseconds). Undefined when timings are unavailable.
  const durationSeconds = chapters?.length
    ? Math.max(
        ...chapters.map((c) => (c.start_timestamp ?? 0) + (c.duration ?? 0))
      ) / 1000
    : undefined;

  return { chapters, durationSeconds };
};
